<template>
  <div class="card">
    <h1>Ordens de Serviço | HISENSE</h1>
    <Toast :style="{ width: $isMobile() ? '85vw' : '' }" />
    <ConfirmDialog></ConfirmDialog>
    <Sidebar
      class="p-sidebar-md"
      :dismissable="false"
      position="right"
      :visible.sync="showSidebar"
      @hide="
        () => {
          showSidebar = false;
          serviceOrder = null;
        }
      "
    >
      <template #footer>
        <div class="flex items-center gap-2">
          <Button
            label="Account"
            icon="pi pi-user"
            class="flex-auto"
            outlined
          ></Button>
          <Button
            label="Logout"
            icon="pi pi-sign-out"
            class="flex-auto"
            severity="danger"
            text
          ></Button>
        </div>
      </template>
      <template #header>
        <div class="p-d-flex p-jc-between p-ai-center">
          <h3>Ordem de Serviço {{ serviceOrder.service_receipt_no }}</h3>
        </div>
      </template>
      <DetailHisense
        :serviceOrder="serviceOrder"
        v-on:createPatAcceptService="createPatAcceptServiceOK"
      />
    </Sidebar>
    <div class="p-grid p-fluid dashboard p-jc-center p-mb-3">
      <W4MstreakIndicators
        :indicators="streakIndicators"
        :loader="indicatorLoading"
        v-on:W4MstreakIndicatorsClick="streakIndicatorsClick"
      />
    </div>
    <div style="height: 65vh">
      <DataTable
        :value="serviceOrderList"
        :paginator="true"
        :rows="perPage"
        :rowsPerPageOptions="[10, 20, 50, 100]"
        :filters.sync="filters"
        filterDisplay="row"
        :loading="loading"
        class="p-datatable-sm"
        responsiveLayout="scroll"
        :scrollable="true"
        scrollHeight="flex"
        :autoLayout="true"
        stripedRows
        :lazy="true"
        :totalRecords="totalRecords"
        @page="fetchData"
        @sort="fetchData"
        @filter="fetchData"
        paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
        currentPageReportTemplate="Mostrar de {first} a {last} de {totalRecords} dados"
      >
        <template #empty> Não existem ordens de serviço. </template>
        <template #loading> A carregar. Por favor Aguarde... </template>
        <template #header>
          <div class="table-header">
            <Button
              icon="pi pi-th-large"
              label="Verificar se existem novas Ordens de Serviço"
              @click="getServiceOrderToApi"
              v-if="can('getServiceOrderToHISENSEApi')"
            />
          </div>
        </template>
        <Column
          field="service_order_id"
          header="Ref"
          sortable
          filterField="service_order_id"
        >
          <template #body="slotProps">
            <span
              class="clickable-item"
              @click="
                () => {
                  serviceOrder = slotProps.data;
                  showSidebar = true;
                }
              "
              >{{ slotProps.data.service_order_id }}
            </span>
          </template>
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por ref"
            />
          </template>
        </Column>
        <Column
          field="service_order_no"
          header="Nº Ordem de Serviços"
          sortable
          filterField="service_order_no"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por nº ordem"
            />
          </template>
        </Column>
        <Column
          field="assign_date"
          header="Data"
          sortable
          filterField="assign_date"
        >
          <template #filter="{ filterModel, filterCallback }">
            <v-date-picker
              v-model="filterModel.value"
              :masks="{ input: 'DD-MM-YYYY' }"
              @input="(date) => onDateFilterChange(date, filterModel, filterCallback)"
            >
              <template v-slot="{ inputValue, inputEvents }">
                <input
                  class="p-inputtext p-component p-column-filter"
                  :value="inputValue"
                  v-on="inputEvents"
                  placeholder="Filtrar por data"
                />
              </template>
            </v-date-picker>
          </template>
        </Column>
        <Column
          field="product_id"
          header="Produto Id"
          sortable
          filterField="product_id"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por produto"
            />
          </template>
        </Column>
        <Column
          field="customer_model"
          header="Modelo"
          sortable
          filterField="customer_model"
        >
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por modelo"
            />
          </template>
        </Column>
        <Column header="Cliente" sortable>
          <template #body="slotProps">
            <span
              v-if="
                slotProps.data.customer_first_name != '' ||
                slotProps.data.customer_last_name != ''
              "
            >
              {{ slotProps.data.customer_first_name }}
              {{ slotProps.data.customer_last_name }}</span
            >
            <span v-else> {{ slotProps.data.customer_full_name }} </span>
          </template>
        </Column>
        <Column field="pat_id" header="PAT" sortable filterField="pat_id">
          <template #filter="{ filterModel, filterCallback }">
            <DebouncedFilterInput
              v-model="filterModel.value"
              :callback="filterCallback"
              placeholder="Filtrar por PAT"
            />
          </template>
        <template #body="slotProps">
            <span
              class="clickable-item"
              @click="goToPat(slotProps.data.pat_id)">
                {{ slotProps.data.pat_id }}
            </span>
          </template>
        </Column>
      </DataTable>
    </div>
  </div>
</template>
<script>
import W4MstreakIndicators from "../components/W4Mstreak/W4MstreakIndicators.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import serviceOrdersService from "../services/serviceOrders.service";
import DetailHisense from "../components/serviceOrders/DetailHisense.vue";
import DebouncedFilterInput from "../components/elements/DebouncedFilterInput.vue";
import { FilterMatchMode } from "primevue/api/";
export default {
  name: "ServiceOrdersHisense",
  components: {
    W4MstreakIndicators,
    DetailHisense,
    DebouncedFilterInput,
  },
  data() {
    return {
      loading: false,
      showSidebar: false,
      indicatorLoading: false,
      currentState: {},
      serviceOrderList: [],
      totalRecords: 0,
      perPage: 20,
      serviceOrder: null,
      filters: {
        service_order_id: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
        service_order_no: {
          value: null,
          matchMode: FilterMatchMode.CONTAINS,
        },
        assign_date: { value: null, matchMode: FilterMatchMode.CONTAINS },
        product_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
        customer_model: { value: null, matchMode: FilterMatchMode.CONTAINS },
        pat_id: { value: null, matchMode: FilterMatchMode.CONTAINS },
      },
    };
  },
  async created() {
    await this.initStreakIndicators();
    this.loading = false;
  },
  methods: {
    async initStreakIndicators() {
      this.indicatorLoading = true;
      this.streakIndicators = [
        {
          title: "Aceites",
          color: "#20d077",
          counter: 0,
        },
        {
          title: "Sem Pat",
          counter: 0,
        },
        {
          title: "Por Aceitar",
          counter: 0,
        },
      ];
      this.streakIndicators = [
        {
          title: "Aceites",
          color: "#20d077",
          counter:
            await serviceOrdersService.countHisenseServiceOrdersAccepted(),
        },
        {
          title: "Sem Pat",
          counter:
            await serviceOrdersService.countHisenseServiceOrdersWithoutPat(),
        },
        {
          title: "Por Aceitar",
          counter:
            await serviceOrdersService.countHisenseServiceOrdersForAccepted(),
        },
      ];
      this.indicatorLoading = false;

      if (this.currentState != {}) {
        return this.streakIndicatorsClick(this.currentState);
      }
    },
    async streakIndicatorsClick(info) {
      this.currentState = info;
      this.fetchData();
    },
    onDateFilterChange(date, filterModel, filterCallback) {
      if (date) {
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        filterModel.value = `${year}-${month}-${day}`;
      } else {
        filterModel.value = null;
      }

      filterCallback();
    },
    buildQueryParams(page = 1) {
      const params = new URLSearchParams();
      params.append('page', page);

      for (const [key, filter] of Object.entries(this.filters)) {
        if (filter.value !== null && filter.value !== '') {
          params.append(`filters[${key}]`, filter.value);
        }
      }

      return params;
    },
    async fetchData(event = {}) {
      if (!this.currentState.indicatorName) return;

      this.loading = true;
      const page = event.page != null ? event.page + 1 : 1;
      const params = this.buildQueryParams(page);
      params.append('per_page', event.rows || this.perPage);

      let response = null;
      if (this.currentState.indicatorName == "Aceites") {
        response = await serviceOrdersService.getHisenseServiceOrdersAccepted(params);
      } else if (this.currentState.indicatorName == "Sem Pat") {
        response = await serviceOrdersService.getHisenseServiceOrdersWithoutPat(params);
      } else if (this.currentState.indicatorName == "Por Aceitar") {
        response = await serviceOrdersService.getHisenseServiceOrdersForAccepted(params);
      }

      if (response) {
        this.serviceOrderList = response.data;
        this.totalRecords = response.total;
        this.perPage = response.per_page;
      }

      this.loading = false;
    },
    createPatAcceptServiceOK() {
      this.showSidebar = false;
      return this.initStreakIndicators();
    },
    getServiceOrderToApi() {
      this.loading = true;
        return serviceOrdersService
          .getHisenseServiceOrdersToAPI()
          .then((response) => {
            this.loading = false;
          if (
            response.jobsError.length == 0 &&
            response.serviceOrders.length == 0
          ) {
            return this.$toast.add({
              severity: "success",
              summary: `Não existem novas ordens de serviço`,
              detail: "",
              life: 3000,
            });
          }

          if (response.serviceOrders.length > 0) {
            return this.$toast.add({
              severity: "success",
              summary: `Ordens de Serviço importadas com sucesso`,
              detail: `Foram importadas com sucesso ${response.serviceOrders.length} ordens de serviço`,
              life: 3000,
            });
          }
          if (response.jobsError.length > 0) {
            return this.$toast.add({
              severity: "warn",
              summary: `Ordens de Serviço com erros`,
              detail: `${response.serviceOrders.length} ordens de serviço contêm erros`,
              life: 3000,
            });
          }
          return this.initStreakIndicators();
        });
    },
    goToPat(patId) {
      this.$router.push(`/pats/${patId}`);
    },
  },
};
</script>
<style>
.p-sidebar-header-content {
  width: 100% !important;
}
</style>
